import angular from 'angular';
import dayjs from 'dayjs';
import { IbPmtConfirmationCarbonFootprintModel } from '../cmpnts/ib-pmt-confirmation-carbon-footprint/ib-pmt-confirmation-carbon-footprint-model';
import { CommonsBrowserStorageService, CommonsSessionStorageService } from 'ib-web-commons/utils';
import { IbSummaryTransformerService } from '../services/ib-summary-transformer.service';
import { CurrencyService } from 'ib-web-commons/app/core/utils/ib-commons-currency-service';
import { CommercialDataMarket, FareOnHoldOptions, Order, PassengerPrices, ReactComponentData, SetSummaryInfoProps, Taxes } from 'src/app/core/models/ib-booking-confirmation-model';
import { HeaderDataType } from 'src/app/core/models/ib-booking-header-model';
import { Summary, SummaryProps } from 'commercial-management--digital--web-components-design--library';
@Controller('ib-pmt-order-confirmation-module',
    ['$rootScope', '$scope', 'PmtModalService', '$window', '$filter', 'PmtOrderConfirmationService', 'DatalayerUtilsService', 'DatalayerEcommerceUtilsService', 'PmtDatalayerConstants', 'PmtUtilsService', 'PmtConstants', 'localStorageService', '$timeout', 'MonetateUtilsService', 'PmtDatalayerUtilsService', 'NewMainHeaderFacade', 'DatalayerEcommerceConstants', 'CommonsUtilService', '$interval', 'DigitalDataService', 'DatalayerMMBConstants', '$compile', '$sce', '$document', 'DatalayerGeneralConstants', 'CommonsConstants', 'DatalayerConstants', 'CommonsSessionStorageService', 'DatalayerBKIConstants', 'IbSummaryTransformerService', 'CurrencyService', 'CommonsBrowserStorageService', 'CommonsUserUtilsService'], [])
class PmtConfirmationController {
    public model: any;
    public ibPayTrace: any;
    public flowApp: any;
    public MODAL_PAYMENT_TAXES = 'ib-modal-payment-taxes.html';
    public MODAL_WARN_ABOUT_LEAVING = 'ib-modal-important-announcement.html';
    public aviosToEarn = null;
    public elitePointsToEarn = null;
    public urlCki = '';
    public LOGIN_ONB = this.PmtConstants.LOGIN_ONB;
    public APP_TYPES = this.PmtConstants.APP_TYPES;
    public isRegister = this.localStorageService.get('isRegister');
    public isRegisterSuccesfull = this.localStorageService.get('isRegisterSuccesfull');
    public isVoluntaryChangeView;
    public isShuttleFlow;
    public insuranceLink;
    public showInsuranceBanner;
    public reactWitgetModel;
    public transferWitgetModel;
    public listLocationWitget: string[];
    public tokenWidget;
    public warning;
    public flags;
    public flightList = [];
    public numPax = 0;
    public isErrorDeleteAll: boolean;
    public isAviosBidAvailable: boolean;
    public flightAviosInfo = this.localStorageService.get('flightAviosInfo');
    public recoglobickActivitiesBki: boolean = false;
    public recoglobickTransferBki: boolean;
    public isPaymentWithAvios: boolean;
    public CalculatedPoints = this.localStorageService.get('CalculatedPoints');
    public isEmptyBasket = this.localStorageService.get('isEmptyBasket');
    public attendanceVouchers = this.localStorageService.get('attendanceVoucher');
    public showWineClubBanner = false;
    public showCarbonFootprintBanner = false;
    public holaMadridFlow: boolean = false;
    public co2InfoBannerModel: IbPmtConfirmationCarbonFootprintModel;
    public upgradingBidsInfo: any;
    public summaryComponent: ReactComponentData<SummaryProps> = <ReactComponentData<SummaryProps>> {
        component: Summary,
        props: <SummaryProps> {}
    };
    public selectedOnHoldOption: FareOnHoldOptions | null = null;
    public paymentViewType: string = null;
    public newPaymentViewType: boolean = false;
    public isIbZero: boolean;
    public appLang:string;
    public appMarket:string;
    public urlUpgrade:string;
    private allianzFusionContractNumber:string = '';
    constructor (private $rootScope,
        private $scope,
        private PmtModalService,
        private $window,
        private $filter,
        private PmtOrderConfirmationService,
        private DatalayerUtilsService,
        private DatalayerEcommerceUtilsService,
        private PmtDatalayerConstants,
        private PmtUtilsService,
        private PmtConstants,
        private localStorageService,
        private $timeout,
        private MonetateUtilsService,
        private PmtDatalayerUtilsService,
        private NewMainHeaderFacade,
        private DatalayerEcommerceConstants,
        private CommonsUtilService,
        private $interval,
        private DigitalDataService,
        private DatalayerMMBConstants,
        private $compile,
        private $sce,
        private $document,
        private DatalayerGeneralConstants: DatalayerGeneralConstantsType,
        private CommonsConstants: CommonsConstantsType,
        private DatalayerConstants: DatalayerConstantsType,
        private CommonsSessionStorageService: CommonsSessionStorageService,
        private DatalayerBKIConstants,
        private IbSummaryTransformerService: IbSummaryTransformerService,
        private CurrencyService: CurrencyService,
        private CommonsBrowserStorageService: CommonsBrowserStorageService,
        private CommonsUserUtilsService: CommonsUserUtilsService
    ) {
        this.appLang = this.$rootScope.appLang;
        this.appMarket = this.$rootScope.appMarket;
        this.urlUpgrade = this.$filter('LinksFilter')('UPGRADE')
            .split('/mi-iberia')[0]
            .concat('/' + this.appMarket.toLocaleLowerCase())
            .concat('/' + this.appLang + '/mi-iberia')
            .concat(this.$filter('LinksFilter')('UPGRADE').split('/mi-iberia')[1]);

        this.localStorageService.set('actualStepFlow', 'confirmation');
        const issueOrderInfo: any = this.CommonsSessionStorageService.get( 'issueOrderInfo' );
        this.selectedOnHoldOption = issueOrderInfo.data.selectedOnHoldOption ?? null;
        this.isIbZero = this.CommonsUserUtilsService.isIbZero();
        // TEST IF GLOBICK TRANSFERS IS HIRED ON ANCILLARIES
        const headerModel:any = this.CommonsSessionStorageService.get('headerModel');
        if (headerModel) {
            let globickData = headerModel.headerModel.shoppingBasket.globickTransfers.hasTransfersGlobick;
            this.recoglobickTransferBki =  globickData ? false : true;
        }

        this.$scope.$on('openSummaryModalTaxesEvent', this.openSummaryModalTaxes);
        this.$scope.$on('openSummaryModalLinksEvent', this.openSummaryModalLinks);
        this.$scope.$on('redirectToMMB', this.redirectToMMB);

        this.$scope.$on('$destroy', () => {
            if (this.flowApp === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_VOLUNTARY_CHANGE || (this.flowApp === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_UNIFIED)) {
                this.PmtDatalayerUtilsService.resetDatalayer();
            }
        });

        this.warning = {'text': [{
            'type': 'normal',
            'text': $filter('translate')('WARNING_REMEMBER_TO_DO_NEW_CHECKIN')
        }]};
        this.isErrorDeleteAll = this.localStorageService.get('errorDeleteAllUPGAVIOS');
        this.isPaymentWithAvios = !!this.localStorageService.get('totalAviosAmount') || (this.localStorageService.get('totalAviosAmount') === 0) || !!this.localStorageService.get('numberFreeUpgrade');
    }
    expiredTokenCallbackTransfer = () => {
        this.initTransferWidget();
    };
    checkIsPro = () => {
        let env: string = '';
        const widgetProMonetate = this.localStorageService.get('widgetProMonetate');
        const envCopy: any = {};
        (<any>Object).assign(envCopy, (<any>window).env);
        if(envCopy.production || widgetProMonetate) {
            env = 'prod';
        }else {
            env = 'test';
        }

        return env;
    };

    generateTransferWitgetModel = () => {
        let transferWitgetModel: any = {};
        const summaryInfo = this.localStorageService.get('summaryInfo');

        if(summaryInfo?.context) {
            this.localStorageService.set('clientBookingId', this.model.confirmationInfo.pnr + '-' + summaryInfo.context.bookingDate.split(' ')[0].replaceAll('-', ''));
        }

        const generate = () => {
            return this.CommonsUtilService.sha256(this.localStorageService.get('clientBookingId')).then((hash) => {
                transferWitgetModel = {
                    env: this.checkIsPro(),
                    token: this.tokenWidget,
                    clientBookingId: hash,
                    pickupLocation: this.model.confirmationInfo.slices[0].segments[this.model.confirmationInfo.slices[0].segments.length - 1].arrival.code, //es obligatorio y se debe de poner un aeropuerto y es el codigo del aeropuerto de destino
                    outboundTripDateTime: this.model.confirmationInfo.slices[0].segments[this.model.confirmationInfo.slices[0].segments.length - 1].arrivalDate.formatedDate.replaceAll(' ', 'T'),
                    airline: this.model.confirmationInfo.slices[0].segments[this.model.confirmationInfo.slices[0].segments.length - 1].marketingCarrier.code,
                    flightNumber: this.model.confirmationInfo.slices[0].segments[this.model.confirmationInfo.slices[0].segments.length - 1].flightNumber,
                    returnTripDateTime: null,
                    returnAirline: null,
                    returnFlightNumber: null,
                    language: this.generateLanguage(),
                    currency: this.getCurrency(),
                    currencyExchange: null,
                    travellers: this.generateTravellers(),
                    getTransferSearchCallback: null,
                    postOrderCallback: null,
                    confirmOrderCallback: this.PmtOrderConfirmationService.confirmTransferOrderCallback,
                    mountLocation: this.generateMountLocation()
                };
                if(this.model.confirmationInfo.slices[1]) {
                    transferWitgetModel.returnTripDateTime = this.model.confirmationInfo.slices[1].segments[this.model.confirmationInfo.slices[1].segments.length - 1].departureDate.formatedDate.replaceAll(' ', 'T');
                    transferWitgetModel.returnAirline = this.model.confirmationInfo.slices[1].segments[this.model.confirmationInfo.slices[1].segments.length - 1].marketingCarrier.code;
                    transferWitgetModel.returnFlightNumber = this.model.confirmationInfo.slices[1].segments[this.model.confirmationInfo.slices[1].segments.length - 1].flightNumber;
                }
                this.localStorageService.set('clientBookingIdTransfer', hash);
                return transferWitgetModel;

            });
        };

        return generate().then((transferWitgetModel) => {
            return transferWitgetModel;
        });
    };

    initTransferWidget = () => {
        if(this.checkShowWidget(true) && this.$window.RecoglobickTransfersWidget && this.recoglobickTransferBki) {
            this.PmtOrderConfirmationService.getTokenWidget(false).then((response) => {
                this.tokenWidget = response.data.access_token;
                this.generateTransferWitgetModel().then((transferWitgetModel) => {
                    this.$window.RecoglobickTransfersWidget.unmount();
                    this.DatalayerUtilsService.updateDatalayerEvents('confirmationWidgetTransfersBKI', 'view', this.model.confirmationInfo.pnr + '_' + transferWitgetModel.clientBookingId);
                    this.$window.RecoglobickTransfersWidget.mount(transferWitgetModel);
                    this.recoglobickTransferBki = true;
                });
            });
        } else {
            this.recoglobickTransferBki = false;
        }
    };

    generateListWidget = () => {
        let list = this.PmtConstants.allowCitiesWinget;
        return list;
    };

    getTokenWidget = () => {
        this.PmtOrderConfirmationService.getTokenWidget(true).then((response) => {
            this.tokenWidget = response.data.access_token;
            this.generateReactWidgetModel().then((widgetModel) => {
                this.$window.RecoglobickActivitiesWidget.unmount();
                this.DatalayerUtilsService.updateDatalayerEvents('confirmationWidgetActivitiesBKI', 'view', this.model.confirmationInfo.pnr + '_' + widgetModel.clientBookingId);
                this.$window.RecoglobickActivitiesWidget.mount(widgetModel);
                this.recoglobickActivitiesBki = true;
            });
        });
    };
    postOrderCallback () {}
    getRecommendationCallback = () => {};

    checkNumberOfPassenger = () => {
        let numberOfPassenger = 0;
        Object.keys(this.model.confirmationInfo.summaryInfo.passengers.generalData).forEach(key => {
            numberOfPassenger = numberOfPassenger + this.model.confirmationInfo.summaryInfo.passengers.generalData[key][0].number;
        });
        return numberOfPassenger;
    };

    checkWithChildren = () => {
        let withChildren = false;
        Object.keys(this.model.confirmationInfo.summaryInfo.passengers.generalData).forEach(key => {
            if (key === 'CHILD' || key === 'INFANT') {
                withChildren = true;
            }
        });
        return withChildren;
    };

    generateLanguage = () => {
        let confirmationDatalayerInfo = this.localStorageService.get('confirmationDatalayerInfo');
        let languageAndMarket;
        if(confirmationDatalayerInfo.idioma === 'es' ) {
            languageAndMarket = confirmationDatalayerInfo.idioma + '-' + 'ES';
        }else if(confirmationDatalayerInfo.idioma === 'en' ) {
            languageAndMarket = confirmationDatalayerInfo.idioma + '-' + 'US';
        }else if(confirmationDatalayerInfo.idioma === 'zh' ) {
            languageAndMarket = confirmationDatalayerInfo.idioma + '-' + 'CN';
        }
        return languageAndMarket;
    };

    generateMountLocation = () => {
        let flowName = this.$rootScope.flowName;
        let flowNameReturned;
        if(flowName === 'BKI' || flowName === 'CKI' || flowName === 'MMB') {
            flowNameReturned = flowName;
        }else {
            flowNameReturned = '';
        }
        return flowNameReturned;
    };

    getCurrency = () => {
        let paymentsInfo = this.localStorageService.get('paymentsInfo');
        let currency = paymentsInfo.currency.code;
        return currency;
    };

    checkBusinessTrip = () => {
        let UserLogged = this.localStorageService.get('userLogged');
        let isBusinessTrip = false;
        if(UserLogged === 'ONB') {
            isBusinessTrip = true;
        }
        return isBusinessTrip;
    };

    generateTravellers = () => {
        const bookingInfo = this.localStorageService.get('bookingInfo');
        let listTravellers = [];
        let travellerTemp = {};
        Object.keys(bookingInfo.passengers).forEach(key => {
            travellerTemp = {};

            travellerTemp = {
                name: bookingInfo.passengers[key].personalInfo.name,
                surname:  bookingInfo.passengers[key].personalInfo.surname,
                email:  '',
                dob:  bookingInfo.passengers[key].personalInfo.birthDate,
                address: '',
                country: '',
                countryPhoneCode: '',
                phone: '',
                countryMobileCode: '',
                mobile: '',
                language: '',
                nationality: '',
                passport: '',
                expenditureDate: '',
                expirationDate: '',
                zipCode: '',
                pickupLocation: ''
            };
            listTravellers.push(travellerTemp);
        });
        return listTravellers;
    };

    expiredTokenCallback = () => {
        this.getTokenWidget();
    };

    generateReactWidgetModel = () => {
        let widgetModel: any = {};
        const summaryInfo = this.localStorageService.get('summaryInfo');
        if(summaryInfo?.context) {
            this.localStorageService.set('clientBookingId', this.model.confirmationInfo.pnr + '-' + summaryInfo.context.bookingDate.split(' ')[0].replaceAll('-', ''));
        }
        const generate = () => {
            return this.CommonsUtilService.sha256(this.localStorageService.get('clientBookingId')).then((hash) => {
                widgetModel = {
                    env: this.checkIsPro(),
                    token: 'Bearer' + ' ' + this.tokenWidget,
                    clientBookingId: hash,
                    startDate: this.model.confirmationInfo.slices[0].segments[0].departureDate.formatedDate.split(' ')[0],
                    endDate: null,
                    location: this.PmtOrderConfirmationService.locationForWidget(this.model.confirmationInfo.slices[0].segments[this.model.confirmationInfo.slices[0].segments.length - 1].arrival.code),
                    totalTickets: this.checkNumberOfPassenger(),
                    businessTrip:  this.checkBusinessTrip(),
                    withChildren: this.checkWithChildren(),
                    ages: null,
                    language: this.generateLanguage(),
                    currency: this.getCurrency(),
                    currencyExchange: null,
                    gaTrackingCode: 'test',
                    travellers: this.generateTravellers(),
                    postOrderCallback: this.postOrderCallback,
                    getRecommendationCallback: this.getRecommendationCallback,
                    confirmOrderCallback: this.PmtOrderConfirmationService.confirmOrderCallback
                };

                if(this.model.confirmationInfo.slices.length === 2){
                    widgetModel.endDate =  this.model.confirmationInfo.slices[1].segments[0].arrivalDate.formatedDate.split(' ')[0];
                }
                this.localStorageService.set('clientBookingIdActivities', hash);
                return widgetModel;

            });
        };
        return generate().then((widgetModel) => {
            return widgetModel;
        });
    };

    checkStayDays = (): boolean => {
        const bookingInfo = this.localStorageService.get('bookingInfo');
        let stayDaysAtDestination: number = 0;
        let oneWayFlight: boolean;
        if (bookingInfo.returnSegments && bookingInfo.airShuttleSegments) {
            if (bookingInfo.returnSegments.length === 0 && bookingInfo.airShuttleSegments.length === 0) {
                oneWayFlight = true;
            } else {
                oneWayFlight = false;
                const initDate = dayjs(bookingInfo.outwardSegments[0].departure.date.slice(0, bookingInfo.outwardSegments[0].departure.date.indexOf(' ')));
                const endDate = dayjs(bookingInfo.returnSegments[0].departure.date.slice(0, bookingInfo.returnSegments[0].departure.date.indexOf(' ')));
                stayDaysAtDestination = endDate.diff(initDate, 'days');
            }
        }

        return oneWayFlight || stayDaysAtDestination > 1;
    };
    checkShowWidget = (showExperiences: boolean) => {
        let showWidget = false;
        const confirmationDatalayerInfo = this.localStorageService.get('confirmationDatalayerInfo');
        const language = confirmationDatalayerInfo.idioma;
        if(this.flowApp === 'BBKI' && this.model.confirmationInfo.slices.length < 3 &&
            this.listLocationWitget.includes(this.PmtOrderConfirmationService.locationForWidget(this.model.confirmationInfo.slices[0].segments[0].arrival.code)) &&
            this.localStorageService.get('paymentsInfo').currency.code === 'EUR' &&
            (language === 'es' || language === 'en' || language === 'zh') && showExperiences
        ){
            showWidget = true;
        }
        return showWidget;
    };

    initRecommendAppWidget = () => {
        if(this.checkShowWidget(this.checkStayDays()) && this.$window.RecoglobickActivitiesWidget){
            this.getTokenWidget();
            this.recoglobickActivitiesBki = true;
        }
    };

    /**
     * Redirect to MMB
     */
    redirectToMMB = () => {
        let bookingInfo = this.localStorageService.get('bookingInfo');
        sessionStorage.setItem('redirectToMMB', 'redirectToMMB');
        if (this.checkIfHasActivitie) {
            sessionStorage.setItem('globickActivitieBuyed', 'true');
        }
        let url = this.$filter('LinksFilter')('MANAGE_MY_BOOKING_LOGGED_LINK', this.$rootScope.appLang) + '#!/chktrp?pnr=' + this.model.confirmationInfo.pnr
         + '&surname=' + bookingInfo?.passengers[0].personalInfo.surname;
        this.$window.open(url, '_self');
    };

    checkIfHasActivitie = () => {
        let haveActivitie: boolean = false;
        const headerModel:any = this.CommonsSessionStorageService.get('headerModel');
        if (headerModel.headerModel.shoppingBasket.globickActivities.hasActivitiesGlobick) {
            haveActivitie = true;
        }
        return haveActivitie;
    };

    /**
         * Open window to print confirmation document  info
         */
    printSummary = () => {
        this.$window.print();
    };

    /**
   * Open the modal with all the information of the flight rates
   * @param {Event} openSummaryModalTaxesEvent Event to lunch function
   * @param {String} modalTemplate The html file of the modal
   * @param {Object} model All the necessary information to show the modal
   */
    openSummaryModalTaxes = (event, modalTemplate, model) => {
        model = model || {};
        if(this.$rootScope.isRedemptionFlow){
            const redemptionOptionId = this.localStorageService.get('selectedFareRedemptionData')?.redemptionOptionId;
            model = this.PmtOrderConfirmationService.cleanTaxes(model, redemptionOptionId);
        }
        angular.extend(model, { 'idModal': modalTemplate });
        this.PmtModalService.showGenericModal(false, modalTemplate, model).result.then(angular.noop, angular.noop);
    };

    /**
     *  Open the modal with all the information
     * @param {Event} openSummaryModalLinksEvent Event to lunch function
     * @param {*} modalTemplate The html file of the modal
     * @param {*} model All the necessary information to show the modal
     */
    openSummaryModalLinks = (event, modalTemplate, model) => {
        model = model || {};
        angular.extend(model, { 'idModal': modalTemplate });
        this.PmtModalService.showGenericModal(false, modalTemplate, model).result.then(angular.noop, angular.noop);
    };

    redirectToCheckIn = ($event) => {
        $event.stopPropagation();
        $event.preventDefault();
        this.$window.open(this.urlCki, '_blank');
    };

    updateDatalayerInformation = () => {
        let issueOrderInfo = this.localStorageService.get('issueOrderInfo'), confirmationDatalayerInfo,
            confirmationDigitalDataInfo = this.localStorageService.get('confirmationDigitalInfo'),
            createOrderData = this.localStorageService.get('createOrderData'),
            selectedLoggedCard = this.localStorageService.get('selectedLoggedCard')?.cardTypeCode,
            paymentMethod = this.localStorageService.get('paymentProvider') ?? (this.localStorageService.get('typeCardIberiaPay') || selectedLoggedCard),
            paymentMethodCode;
        const voucherDiscount = issueOrderInfo?.data?.order?.voucherDiscount;
        if (issueOrderInfo && issueOrderInfo.data && issueOrderInfo.data.contextMetadata && issueOrderInfo.data.contextMetadata.currencies && issueOrderInfo.data.contextMetadata.currencies.length < 1 && createOrderData && createOrderData.contextMetadata) {
            issueOrderInfo.data.contextMetadata.currencies[0] = createOrderData.contextMetadata.currencies[0];
        }
        paymentMethodCode = this.getPaymentMethodCode(paymentMethod);
        /* INIT DELETE GA4 MIGRATION*/
        this.localStorageService.set('confirmationDatalayerCallBack', this.$window.datalayer_general);
        confirmationDatalayerInfo = this.DatalayerEcommerceUtilsService.updateDatalayerInfoPayments( issueOrderInfo );
        const voucherAmount = voucherDiscount?.amount || null;
        const giftCardAmount = voucherDiscount?.type === this.PmtConstants.DISCOUNT_TYPES.GIFT_CARD ? voucherAmount : null;

        if (confirmationDatalayerInfo) {
            this.DatalayerEcommerceUtilsService.addDataLayerEcommerceInfo(confirmationDatalayerInfo.ecommerce);
            if (paymentMethodCode) {
                confirmationDatalayerInfo.generalInfo[this.PmtDatalayerConstants.DATALAYER_INFO.CREDITCARD_TYPE] = paymentMethodCode;
            }
            voucherAmount && ( confirmationDatalayerInfo.generalInfo[ this.PmtDatalayerConstants.DATALAYER_INFO.VOUCHER_DISCOUNT_AMOUNT ] = voucherAmount );
            giftCardAmount && ( confirmationDatalayerInfo.generalInfo[ this.PmtDatalayerConstants.DATALAYER_INFO.GIFT_CARD ] = giftCardAmount );
            this.DatalayerUtilsService.addDataLayerInfo(confirmationDatalayerInfo.generalInfo);
        }
        /* FINISH DELETE GA4 MIGRATION*/
        if (confirmationDigitalDataInfo) {
            if (paymentMethodCode) {
                confirmationDigitalDataInfo[this.DatalayerGeneralConstants.PAYMENT_METHOD] = paymentMethodCode;
            }
            voucherAmount && ( confirmationDigitalDataInfo[ this.DatalayerBKIConstants.VOUCHER_DISCOUNT ] = voucherAmount );
            giftCardAmount && ( confirmationDigitalDataInfo[ this.DatalayerBKIConstants.GIFT_CARD ] = giftCardAmount );
            this.DatalayerUtilsService.addDigitalDataInfo(confirmationDigitalDataInfo);
        }
        if (this.model.appliedDiscounts && this.model.appliedDiscounts.status && !!this.model.appliedDiscounts.types['AVIOS_REDEMPTION']) {
            const digitalData = { AviosUsed: this.model.confirmationInfo?.price.totalPriceAvios };
            this.DatalayerUtilsService.addDigitalDataInfo(digitalData);
        }
        /* INIT DELETE GA4 MIGRATION*/
        (!this.newPaymentViewType) && this.DatalayerUtilsService.generateConfirmationDatalayerObject();
        /* FINISH DELETE GA4 MIGRATION*/
        this.DatalayerUtilsService.generateConfirmationDigitalDataObject();
    };

    getPaymentMethodCode = (paymentMethod:string):string =>{
        let code:string;
        paymentMethod = this.getPaymentType(paymentMethod);
        switch(paymentMethod){
                case this.PmtConstants.PAYMENTS_METHODS_PROVIDERS.PAYPAL:
                    code = this.PmtConstants.PAYMENTS_METHODS_CODE.PAYPAL;
                    break;
                case this.PmtConstants.PAYMENTS_METHODS_PROVIDERS.BIZUM:
                    code = this.PmtConstants.PAYMENTS_METHODS_CODE.BIZUM;
                    break;
                case (this.PmtConstants.PAYMENTS_METHODS_PROVIDERS.SOFORT || this.PmtConstants.PAYMENTS_METHODS_PROVIDERS.IDEAL):
                    code = this.PmtConstants.PAYMENTS_METHODS_CODE.SOFORT_IDEAL;
                    break;
                case this.PmtConstants.PAYMENTS_METHODS_PROVIDERS.NEMURU:
                    code = this.PmtConstants.PAYMENTS_METHODS_CODE.NEMURU;
                    break;
                default: code = paymentMethod;
                    break;
        }
        return code;
    };

    getPaymentType = (paymentMethod:string):string =>{
        const paymentTypes = {
            FULL_PAY_AVIOS : this.PmtConstants.PAYMENTS_METHODS_CODE.FULL_AVIOS,
            VOUCHER: this.PmtConstants.PAYMENTS_METHODS_CODE.VOUCHER
        };
        return paymentTypes[this.localStorageService.get('paymentType')] || paymentMethod;
    };

    openBagOnBoardUrl = (urlbob) => {
        this.$window.open(urlbob, '_blank');
    };

    openHolaMadridActivities = () => {
        const url = window.location.href;
        const baseUrl = url.substring(0, url.indexOf('/', url.indexOf('/') +2));
        this.$window.open(baseUrl + '/' + this.$rootScope.appMarket + '/' +  this.$rootScope.appLang + '/stopover-in-madrid/experiencias/', '_blank');
    };

    setOrderInfoDatalayer = () => {
        var flowApp = this.flowApp;
        var bookingInfo = this.localStorageService.get('bookingInfo');
        var infoDataLayer = this.localStorageService.get('confirmationDatalayerCallBack');
        var orderInfo = { 'OrderId': bookingInfo.order.orderId };
        var content;
        if (orderInfo && orderInfo.OrderId && (flowApp === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_VOLUNTARY_CHANGE || flowApp === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_UNIFIED)) {
            this.DatalayerUtilsService.addDataLayerInfo(orderInfo);
            Object.keys(infoDataLayer).forEach( (element) => {
                content = {};
                content[element] = infoDataLayer[element];
                if (this.notExistOnDataLayer(element)) {
                    this.DatalayerUtilsService.addDataLayerInfo(content);
                }
            });
        }
        this.DatalayerUtilsService.sendDatalayerEvent(this.PmtDatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
    };

    notExistOnDataLayer = (element) => {
        var response = false;
        switch (element) {
                case this.PmtDatalayerConstants.DATALAYER_INFO.LANGUAGE: response = false; break;
                case this.PmtDatalayerConstants.DATALAYER_INFO.MARKET: response = false; break;
                case this.PmtDatalayerConstants.DATALAYER_INFO.WEB_VERSION: response = false; break;
                case this.PmtDatalayerConstants.DATALAYER_INFO.WEB_MODE: response = false; break;
                case this.PmtDatalayerConstants.DATALAYER_INFO.QUADRIGAM: response = false; break;
                case this.PmtDatalayerConstants.DATALAYER_INFO.CODE: response = false; break;
                case this.PmtDatalayerConstants.DATALAYER_INFO.USER_STATE: response = false; break;
                case this.DatalayerEcommerceConstants.DATALAYER_ECOMMERCE.TOTAL_PRICE_WITHOUT_TAX: response = false; break;
                case this.DatalayerEcommerceConstants.DATALAYER_ECOMMERCE.TOTAL_PRICE: response = false; break;
                default: response = true;
        }
        return response;
    };

    /**
     * Warns the user when browser back button is pressed and gives him/her the option of staying in the page or leaving to the homepage.
     */
    warnUserOnBackPressed = () => {
        const cvFlowInitialized = this.localStorageService.get('cvFlowInitialized');
        this.$window.scrollTo(0, 0);
        history.pushState(null, null, location.href);
        this.$window.onpopstate =  () => {
            if(angular.isDefined(cvFlowInitialized) && cvFlowInitialized) {
                this.$rootScope.$broadcast('cvConfimationBackButtonPressed');
            } else if (this.flowApp === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_BIDS) {
                this.PmtModalService.finishWaiting();
                this.localStorageService.get('actualStepFlow') === 'confirmation' && !this.localStorageService.get('payFromTransfer') ? this.PmtModalService.showGenericModal(true, this.MODAL_WARN_ABOUT_LEAVING).result.then(history.pushState(null, null, location.href), angular.noop) : angular.noop;
                this.localStorageService.remove('payFromTransfer');
            } else {
                //
                this.PmtModalService.closeAllCurrentModals();
                this.localStorageService.get('actualStepFlow') === 'confirmation' && !this.localStorageService.get('payFromTransfer') ? this.PmtModalService.showGenericModal(true, this.MODAL_WARN_ABOUT_LEAVING).result.then(history.pushState(null, null, location.href), angular.noop) : angular.noop;
                this.localStorageService.remove('payFromTransfer');
            }
        };
    };

    setTitlePage = () => {
        switch (this.flowApp) {
                case this.PmtConstants.APP_TYPES.ONHOLD:
                    this.CommonsUtilService.setTitlePage('BKI_TITLE_PAGE_CONFIRMATION_PAGE_ONHOLD');
                    break;
                case this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_BIDS:
                    this.CommonsUtilService.setTitlePage('MMB_TITLE_PAGE_BID_CONFIRMATION');
                    break;
                case this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_VOLUNTARY_CHANGE:
                case this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_UNIFIED:
                    this.CommonsUtilService.setTitlePage('MMB_TITTLE_PAGE_CONFIRMATION_VC');
                    break;
                case this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_ONHOLD:
                    this.CommonsUtilService.setTitlePage('MMB_TITLE_ON_HOLD_CONF_CONFIRMATION');
                    break;
                case this.PmtConstants.APP_TYPES.BOOKING:
                    this.CommonsUtilService.setTitlePage(this.getBKITitlePage());
                    break;
                default:
                    this.CommonsUtilService.setTitlePage('GENERAL_TITLE_CONFIRMATION_PAGE');
                    break;
        }
    };

    private getBKITitlePage = () =>{
        const isMulticity = this.localStorageService.get('multiCitySearch');
        if(this.isShuttleFlow) return 'BKI_SHUTTLE_TITLE_CONFIRMATION_PAGE';
        if(isMulticity) return 'BKI_MULTI_TITLE_CONFIRMATION_PAGE';
        return 'GENERAL_TITLE_CONFIRMATION_PAGE';
    };

    getEnvUrlToGetWidgetCode = () => {
        let env: string = '';
        const envCopy: any = {};
        (<any>Object).assign(envCopy, (<any>window).env);
        return envCopy.urlEnvironment;
    };

    areInvoiceWarnings = (warningInfo) => {
        return warningInfo.code === this.PmtConstants.INVOICE_WARNINGS.INVOICES_FAIL || warningInfo.code === this.PmtConstants.INVOICE_WARNINGS.INVOICES_PARTIAL_FAIL
            || warningInfo.code === this.PmtConstants.INVOICE_WARNINGS.NO_TICKET_NUMBER || warningInfo.code === this.PmtConstants.INVOICE_WARNINGS.WARNING_INVOICE_NOT_ISSUED
            || warningInfo.code === this.PmtConstants.INVOICE_WARNINGS.WARNING_MEMBERSHIP_INFORMATION_INCOMPLETE || warningInfo.code === this.PmtConstants.INVOICE_WARNINGS.WARNING_MEMBERSHIP_NOT_OBTAINED
            || warningInfo.code === this.PmtConstants.INVOICE_WARNINGS.WARNING_MEMBERSHIP_PROBLEM || warningInfo.code === this.PmtConstants.INVOICE_WARNINGS.WARNING_ORDER_INFORMATION_INCOMPLETE
            || warningInfo.code === this.PmtConstants.INVOICE_WARNINGS.NO_MARKET_FOUND;
    };

    loadWidgetsScripts = () => {
        let scriptActivitiesVendor, scriptActivitiesMain, scriptActivitiesRunTime, cssActivitiesVendor, cssActivitiesMain, urlActivities, baseUrl, widgetActivitiesVersion, widgetTransfersVersion;
        let scriptTransferVendor, scriptTransferMain, scriptTransferRunTime, cssTransfersMain, urlTransfers;

        widgetActivitiesVersion = '2.2.4';
        widgetTransfersVersion = '2.1.3';
        baseUrl = this.getEnvUrlToGetWidgetCode();
        urlActivities = baseUrl + 'iberia-web-content/build-recoglobick-activities/' + widgetActivitiesVersion;
        urlTransfers = baseUrl + 'iberia-web-content/build-recoglobick-transfers/' + widgetTransfersVersion;

        //activities
        scriptActivitiesVendor = '<script type="text/javascript" src="' + this.$sce.trustAsResourceUrl(urlActivities + '/static/js/2.vendor.chunk.js') + '"</script>';
        scriptActivitiesMain = '<script type="text/javascript" src="' + this.$sce.trustAsResourceUrl(urlActivities + '/static/js/main.chunk.js') + '"</script>';
        scriptActivitiesRunTime = '<script type="text/javascript" src="' + this.$sce.trustAsResourceUrl(urlActivities + '/static/js/runtime-main.js') + '"</script>';
        cssActivitiesVendor = '<link rel="stylesheet" href="' + this.$sce.trustAsResourceUrl(urlActivities + '/static/css/2.vendor.chunk.css') + '">';
        cssActivitiesMain = '<link rel="stylesheet" href="' + this.$sce.trustAsResourceUrl(urlActivities + '/static/css/main.chunk.css') + '">';
        angular.element(this.$document).find('body').prepend(this.$compile(scriptActivitiesVendor)(this.$scope));
        angular.element(this.$document).find('body').prepend(this.$compile(scriptActivitiesMain)(this.$scope));
        angular.element(this.$document).find('body').prepend(this.$compile(scriptActivitiesRunTime)(this.$scope));

        angular.element(this.$document).find('body').prepend(this.$compile(cssActivitiesVendor)(this.$scope));
        angular.element(this.$document).find('body').prepend(this.$compile(cssActivitiesMain)(this.$scope));


        //transfers
        scriptTransferVendor = '<script type="text/javascript" src="' + this.$sce.trustAsResourceUrl(urlTransfers + '/static/js/2.vendor.chunk.js') + '"</script>';
        scriptTransferMain = '<script type="text/javascript" src="' + this.$sce.trustAsResourceUrl(urlTransfers + '/static/js/main.chunk.js') + '"</script>';
        scriptTransferRunTime = '<script type="text/javascript" src="' + this.$sce.trustAsResourceUrl(urlTransfers + '/static/js/runtime-main.js') + '"</script>';
        cssTransfersMain = '<link rel="stylesheet" href="' + this.$sce.trustAsResourceUrl(urlTransfers + '/static/css/main.chunk.css') + '">';
        angular.element(this.$document).find('body').prepend(this.$compile(scriptTransferVendor)(this.$scope));
        angular.element(this.$document).find('body').prepend(this.$compile(scriptTransferMain)(this.$scope));
        angular.element(this.$document).find('body').prepend(this.$compile(scriptTransferRunTime)(this.$scope));

        angular.element(this.$document).find('body').prepend(this.$compile(cssTransfersMain)(this.$scope));
    };

    displayWineClubBanner = () => {
        const calculateFrequencyDisplay = () => {
            const number= Math.floor(Math.random()*Math.floor(3));
            return (number!==0);
        };
        const isFrequentFlyer = () => {
            let issueOrderInfo = this.localStorageService.get('issueOrderInfo'), passengers = [], passengersIndex;
            if(issueOrderInfo && issueOrderInfo.data && issueOrderInfo.data.passengers.length > 0) {
                passengers = issueOrderInfo.data.passengers;
                for (passengersIndex = 0; passengersIndex < passengers.length; passengersIndex++) {
                    if(passengers[passengersIndex].frequentFlyerInfo) {
                        return true;
                    }
                }
            }
            return false;
        };

        this.showWineClubBanner = this.model?.confirmationInfo?.wineClub && calculateFrequencyDisplay() && isFrequentFlyer();
    };

    displayCarbonFootprintBanner = () => {
        this.co2InfoBannerModel = {
            name: this.extractFirstPassengerName(),
            kilosCo2eFormatted:  this.model.confirmationInfo.co2Info?.kilosCo2eFormatted,
            priceFormatted: this.model.confirmationInfo.co2Info?.price,
            flight: {
                numPax: this.numPax,
                segments: this.flightList
            }
        };
        this.showCarbonFootprintBanner =
            Boolean(!this.model.confirmationInfo.summaryInfo?.ancillaries?.carbonFootprint && this.model.confirmationInfo.co2Info?.hasCarbonFootprint);
    };

    extractFirstPassengerName = () => {
        const fullName = this.model.confirmationInfo.summaryInfo.passengers.personalData[0].name;
        const surname = this.model.confirmationInfo.summaryInfo.passengers.personalData[0].surname;
        return fullName.replace(surname, '').trim();
    };

    completeTransferFlow = (): void => {
        const widgetVersion = '2.2.3';
        const baseUrl = this.getEnvUrlToGetWidgetCode();
        const urlTransfers = baseUrl + 'iberia-web-content/build-recoglobick-transfers/' + widgetVersion;
        const scriptTransferVendor = urlTransfers + '/static/js/2.vendor.chunk.js';
        const scriptTransferMain = urlTransfers + '/static/js/main.chunk.js';
        const scriptTransferRunTime = urlTransfers + '/static/js/runtime-main.js';
        const cssTransfersMain = urlTransfers + '/static/css/main.chunk.css';
        angular.element('script[src="' + scriptTransferVendor + '"]').remove();
        angular.element('script[src="' + scriptTransferMain + '"]').remove();
        angular.element('script[src="' + scriptTransferRunTime + '"]').remove();
        angular.element('link[href="' + cssTransfersMain + '"]').remove();
        this.$window.RecoglobickTransfersWidget.unmount();
    };

    activate = () => {
        let fareData, bookingInfo, pointsData;
        this.loadWidgetsScripts();
        this.$timeout( () => {
            this.setTitlePage();
        }, 1600);
        this.model = {};
        this.model.confirmationInfo = {};
        this.model.totalPriceInfo = {};
        this.ibPayTrace = this.localStorageService.get('ibPayTrace');
        this.model.showWineClubBanner = this.localStorageService.get('showWineClubBanner');
        this.flowApp = this.localStorageService.get('flowApp');
        this.flightAviosInfo = this.localStorageService.get('flightAviosInfo') || null;
        this.isEmptyBasket = this.localStorageService.get('isEmptyBasket') || null;
        this.upgradingBidsInfo = this.localStorageService.get('upgradingBidsInfo') || null;
        bookingInfo = this.localStorageService.get( 'bookingInfo' );
        this.paymentViewType = this.CommonsSessionStorageService.get( 'paymentViewType' );
        this.newPaymentViewType = this.paymentViewType === 'NEW' ? true : false;
        const getConfirmationAncillariesSucces = () => {
            this.PmtOrderConfirmationService.getConfirmationInfo().then((response) => {
                this.model = response;
                this.model.appliedDiscounts = this.localStorageService.get('putWithoutOfferBin') ? { status: false } : this.localStorageService.get('paymentsInfo') && this.localStorageService.get('paymentsInfo').appliedDiscounts ? this.localStorageService.get('paymentsInfo').appliedDiscounts : null;
                angular.element(this.$window).triggerHandler('resize');
                this.updateDatalayerInformation();
                if ( this.newPaymentViewType && (this.flowApp === this.PmtConstants.APP_TYPES.BOOKING || this.flowApp === this.PmtConstants.APP_TYPES.ONHOLD) ) {
                    this.summaryComponent.props = this.getInitialSummary();
                }
                if ( this.flowApp === this.PmtConstants.APP_TYPES.BOOKING ) {
                    /* INIT DELETE GA4 MIGRATION*/
                    const voucherElect = this.PmtUtilsService.voucherSelected(this.model.appliedDiscounts);
                    this.isShuttleFlow ? this.DatalayerUtilsService.addShuttleDatalayer(this.localStorageService.get('actualStepFlow'), this.model): '';
                    this.DatalayerUtilsService.addDataLayerInfo(voucherElect);
                    /* FINISH DELETE GA4 MIGRATION*/
                    const eligibleVoucherElect = this.PmtUtilsService.eligibleVoucherSelected(this.model.appliedDiscounts);
                    this.isShuttleFlow ? this.DatalayerUtilsService.addShuttleDigitalData(this.localStorageService.get('actualStepFlow'), this.model): '';
                    this.DatalayerUtilsService.addDigitalDataInfo(eligibleVoucherElect);
                    this.model.userPreferencesStoredWarning = this.localStorageService.get('savePassengerPreferencesResponse');
                    this.deleteTemporalPNR();
                }
                /* INIT DELETE GA4 MIGRATION */
                this.DatalayerUtilsService.sendDatalayerEvent(this.PmtDatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
                /* FINISH DELETE GA4 MIGRATION */
                this.DigitalDataService.emitViewEvent();
                this.updateDatalayerInfoPurchase();
                if (this.flowApp !== this.PmtConstants.APP_TYPES.MANAGEMYBOOKING || this.flowApp !== this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_ONHOLD) {
                    this.MonetateUtilsService.updateMonetateWithQuadrigam(this.PmtConstants.MONETATE_INFO.SETPAGETYPE, this.localStorageService.get('pmtModelInfo').quadrigams.confirmation);
                    if (!this.$rootScope.isPointsOBFlow && (this.flowApp === 'BBKI' || this.flowApp === 'BBKIOH') && !this.$rootScope.isShuttleFlow) {
                        this.MonetateUtilsService.addFlightBookingMonetate(this.localStorageService.get('bookingUrlParams'), this.localStorageService.get('originDestination'), this.model.confirmationInfo, this.localStorageService.get('fareFamilyConditionsInfo') ? this.localStorageService.get('fareFamilyConditionsInfo') : this.localStorageService.get('fareData').fareFamilyConditions);
                        this.$rootScope.$broadcast('updateDatalayer');
                    }
                    if(this.flowApp === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_ONHOLD){
                        this.$rootScope.$broadcast('changeStatusBasket', false);
                    }
                }
                this.$timeout(() => {
                    this.PmtModalService.finishWaiting();
                    if(this.flowApp!== this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_VOLUNTARY_CHANGE && this.flowApp!== this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_UNIFIED && this.flowApp!== this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_BIDS) {
                        this.PmtModalService.closeAllCurrentModals();
                    }
                });
                this.$rootScope.$broadcast('sendUpdateToMonetate');
                this.urlCki = this.$filter('LinksFilter')('CHECKIN_ONLINE_APP') + '?language=' + this.$rootScope.appLang + '&market=' + this.$rootScope.appMarket + '&pnr=' + encodeURIComponent(this.model.confirmationInfo.pnr) + '&surname=' + encodeURIComponent(this.model.confirmationInfo.summaryInfo.passengers.personalData[0].surname);
                this.$timeout(() => {
                    this.initRecommendAppWidget();
                    this.initTransferWidget();
                }, 1000);

                this.displayWineClubBanner();
                this.displayCarbonFootprintBanner();
                this.localStorageService.set('confirmationInfo', this.model.confirmationInfo);
            });
        };
        if (!this.$rootScope.isShuttleFlow) {
            this.$rootScope.isShuttleFlow = this.localStorageService.get('isShuttleFlow');
        }
        if (!this.$rootScope.isRedemptionFlow) {
            this.$rootScope.isRedemptionFlow = this.localStorageService.get('isRedemptionFlow');
        } else {
            var headerModel = this.localStorageService.get('headerModel');
            var customerData = this.localStorageService.get('customerData');
            if (headerModel && customerData) {
                headerModel.greyBarModel.loggedData.avios = customerData.generalInfo.aviosTransformed;
                this.NewMainHeaderFacade.updateHeader(headerModel);
            }
            sessionStorage.removeItem('customerData');
            sessionStorage.removeItem('retrieveMemberDetail');
        }
        if (!this.$rootScope.isPointsOBFlow) {
            this.$rootScope.isPointsOBFlow = this.localStorageService.get('isPointsOBFlow');
        }
        if (this.flowApp === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_BIDS) {
            this.$rootScope.$broadcast('toConfirmationBidEvent');
        }
        this.insuranceLink = 'https://iberia.allianz-assistance.com/';
        if (this.$rootScope.appMarket === 'ES') {
            this.showInsuranceBanner = true;
        } else {
            this.showInsuranceBanner = false;
        }
        this.isShuttleFlow = this.localStorageService.get('isShuttleFlow');
        this.localStorageService.set('previousStepFlow', this.localStorageService.get('actualStepFlow'));
        this.localStorageService.set('actualStepFlow', 'confirmation');
        if (this.flowApp !== this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_VOLUNTARY_CHANGE && this.flowApp !== this.PmtConstants.APP_TYPES.BOOKING && this.flowApp !== this.PmtConstants.APP_TYPES.ONHOLD && this.flowApp !== this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_UNIFIED) {
            this.$rootScope.showMainHeader = false;
            this.$rootScope.showHeaders = false;
            this.isVoluntaryChangeView = false;
        } else if (this.flowApp === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_VOLUNTARY_CHANGE || this.flowApp === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_UNIFIED) {
            this.isVoluntaryChangeView = true;
        } else {
            this.$rootScope.showMainHeader = false;
            this.$rootScope.showHeaders = true;
            this.isVoluntaryChangeView = false;
        }
        this.localStorageService.set('paySucces', true);
        this.PmtModalService.showWaitingModal('ib-modal-loading-plane-pmt', 'ib-modals ib-modals--transparent', true);
        const newsletterPersonalData = this.localStorageService.get('newsletterPersonalDataToSave');
        if (this.flowApp === this.PmtConstants.APP_TYPES.BOOKING || this.flowApp === this.PmtConstants.APP_TYPES.ONHOLD) {
            if (newsletterPersonalData && !this.PmtUtilsService.isUserLogged()) {
                this.PmtOrderConfirmationService.saveNewsletterSubscription(newsletterPersonalData);
            }
            this.NewMainHeaderFacade.updateSteps(this.localStorageService.get('actualStepFlow'));
            this.NewMainHeaderFacade.showLogin();
        }
        if (this.flowApp === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_ONHOLD) {
            this.$rootScope.$broadcast('resetHeaderCurrency');
            this.NewMainHeaderFacade.showLoginMMBOnHold();
        }
        switch (true) {
                case this.CommonsUtilService.isFlowAppByQuadrigam(this.flowApp, this.PmtConstants.APP_TYPES.BOOKING, this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_ONHOLD) && !this.$rootScope.isRedemptionFlow && !this.localStorageService.get('ancillariesInfo'):
                    this.PmtOrderConfirmationService.getConfirmationAncillaries().then(getConfirmationAncillariesSucces, getConfirmationAncillariesSucces);
                    break;
                case this.CommonsUtilService.isFlowAppByQuadrigam(this.flowApp, this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_VOLUNTARY_CHANGE, this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_UNIFIED):
                    let quadrigamConfirmation = '', quadrigamPayments = '', modelInfoCopy = this.localStorageService.get('pmtModelInfo');

                    if (this.$rootScope.isDisruptionFlow) {
                        const typeFlowDisruption = this.localStorageService.get('typeDisruptionFlow') || null, optional = this.localStorageService.get('optionalFlight') || false;
                        if (typeFlowDisruption) {
                            switch (typeFlowDisruption) {
                                    /* With flexibilization */
                                    case this.DatalayerMMBConstants.QUADRIGAM_BY_DISRUPTION_FLOW.ALTERNATIVE_TOTAL_WITH_FLEXIBILIZATION:
                                        quadrigamConfirmation = this.PmtConstants.QUADRIGAMS.MMB_VOLUNTARY_CHANGE_CONFIRMATION;
                                        quadrigamPayments = this.PmtConstants.QUADRIGAMS.MMB_ANCILLARIES_CHANGE_WITH_ALTERNATIVE_FLEXIB_TOTAL_PAYMENTS;
                                        break;
                                    case this.DatalayerMMBConstants.QUADRIGAM_BY_DISRUPTION_FLOW.ALTERNATIVE_PARCIAL_WITH_FLEXIBILIZATION:
                                        if (optional) {
                                            quadrigamConfirmation = this.PmtConstants.QUADRIGAMS.MMB_ANCILLARIES_CHANGE_WITH_ALTERNATIVE_AND_FLEXIB_TOTAL_OPTIONAL_CONFIRMATION;
                                            quadrigamPayments = this.PmtConstants.QUADRIGAMS.MMB_ANCILLARIES_CHANGE_WITH_ALTERNATIVE_AND_FLEXIB_TOTAL_OPTIONAL_PAYMENT;
                                        } else {
                                            quadrigamConfirmation = this.PmtConstants.QUADRIGAMS.MMB_ANCILLARIES_CHANGE_WITH_ALTERNATIVE_FLEXIB_PARCIAL_CONFIRMATION;
                                            quadrigamPayments = this.PmtConstants.QUADRIGAMS.MMB_ANCILLARIES_CHANGE_WITH_ALTERNATIVE_FLEXIB_PARCIAL_PAYMENT;
                                            if(bookingInfo.order.status === this.PmtConstants.MMB_DISRUPTION_ORDER_STATUS.UN || bookingInfo.order.status === this.PmtConstants.MMB_DISRUPTION_ORDER_STATUS.UNTK) {
                                                quadrigamConfirmation = this.PmtConstants.QUADRIGAMS.MMB_VOLUNTARY_CHANGE_CONFIRMATION;
                                            }
                                        }
                                        break;
                                    /* END With flexibilization */
                                    /* Without flexibilization */
                                    case this.DatalayerMMBConstants.QUADRIGAM_BY_DISRUPTION_FLOW.ALTERANTIVE_TOTAL_WITHOUT_FLEXIBILIZATION:
                                        quadrigamConfirmation = this.PmtConstants.QUADRIGAMS.MMB_ANCILLARIES_MODAL_ACCEPT_CHANGE_WITH_ONLY_ALTERNATIVE_TOTAL_CONFIRMATION;
                                        quadrigamConfirmation = this.PmtConstants.QUADRIGAMS.MMB_ANCILLARIES_MODAL_ACCEPT_CHANGE_WITH_ONLY_ALTERNATIVE_TOTAL_PAYMENT;
                                        break;
                                    case this.DatalayerMMBConstants.QUADRIGAM_BY_DISRUPTION_FLOW.ALTERNATIVE_PARCIAL_WITHOUT_FLEXIBILIZATION:
                                        quadrigamConfirmation = this.PmtConstants.QUADRIGAMS.MMB_ANCILLARIES_MODAL_ACCEPT_CHANGE_WITH_ONLY_ALTERNATIVE_PARCIAL_CONFIRMATION;
                                        quadrigamConfirmation = this.PmtConstants.QUADRIGAMS.MMB_ANCILLARIES_MODAL_ACCEPT_CHANGE_WITH_ONLY_ALTERNATIVE_PARCIAL_PAYMENT;
                                        break;
                                    default: quadrigamConfirmation = '';
                            }
                        } else {
                            quadrigamConfirmation = this.PmtConstants.QUADRIGAMS.MMB_VOLUNTARY_CHANGE_CONFIRMATION;
                            quadrigamPayments = this.PmtConstants.QUADRIGAMS.MMB_ANCILLARIES_FLEXIBILIZATION_INVOLUNTARY_PAYMENT;
                        }
                    } else {
                        quadrigamConfirmation = this.PmtConstants.QUADRIGAMS.MMB_VOLUNTARY_CHANGE_CONFIRMATION;
                        quadrigamPayments = this.PmtConstants.QUADRIGAMS.MMB_VOLUNTARY_CHANGE_PAYMENT;
                    }
                    modelInfoCopy.quadrigams.confirmation = quadrigamConfirmation;
                    modelInfoCopy.quadrigams.payments = quadrigamPayments;
                    this.localStorageService.set('pmtModelInfo', modelInfoCopy);

                    let process = this.DatalayerMMBConstants.DIGITAL_DATA_PROCESS[quadrigamConfirmation];
                    let step = this.DatalayerMMBConstants.DIGITAL_DATA_STEP[quadrigamConfirmation];

                    if(this.PmtConstants.MMB_DISRUPTION_PAYMENT_QUADRIGAM_UN_UNTK.includes(quadrigamConfirmation)) {
                        switch (bookingInfo.order.status) {
                                case this.PmtConstants.MMB_DISRUPTION_ORDER_STATUS.UN: //involuntary change without alternative (UN)
                                    process = this.PmtConstants.PROCESS_DISRUPTION.CANCELLATION;
                                    break;
                                case this.PmtConstants.MMB_DISRUPTION_ORDER_STATUS.UNTK: //involuntary change with alternative (UN/TK)
                                    process = this.PmtConstants.PROCESS_DISRUPTION.CANCELLATION_ALTERNATIVE;
                                    break;
                        }
                    }
                    this.DatalayerUtilsService.setProcessAndStep(process, step, quadrigamConfirmation);
                    this.$rootScope.$emit('confirmationMMBVCEvent');
                    getConfirmationAncillariesSucces();
                    break;
                case this.CommonsUtilService.isFlowAppByQuadrigam(this.flowApp, this.PmtConstants.APP_TYPES.ONHOLD):
                    this.DatalayerUtilsService.setProcessAndStep(this.CommonsConstants.PROCESS.ON_HOLD, this.DatalayerConstants.DATALAYER_VIEWS.ONHOLD_CONFIRMATION, this.PmtConstants.QUADRIGAMS.BKIOH_CONFIRMATION);
                    getConfirmationAncillariesSucces();
                    break;
                case this.CommonsUtilService.isFlowAppByQuadrigam(this.flowApp, this.PmtConstants.APP_TYPES.MANAGEMYBOOKING):
                    this.DatalayerUtilsService.setProcessAndStep(this.DatalayerMMBConstants.DIGITAL_DATA_PROCESS.MOCAPI, this.DatalayerMMBConstants.DIGITAL_DATA_STEP.MOCAPI);
                    getConfirmationAncillariesSucces();
                    break;
                default:
                    getConfirmationAncillariesSucces();
        }
        if (this.flowApp === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_VOLUNTARY_CHANGE || this.flowApp === this.PmtConstants.APP_TYPES.MANAGEMYBOOKING_UNIFIED) {
            this.setOrderInfoDatalayer();
        }
        fareData = this.localStorageService.get('fareData');
        const numPax = bookingInfo.passengers.length;
        const flightList = [];
        bookingInfo.order.slices.forEach(slice => slice.segments.forEach(segment => {
            const item = {from: segment.departure.code, to: segment.arrival.code, cabin: segment.cabin.type};
            flightList.push(item);
        }));
        this.flightList = flightList;
        this.numPax = numPax;
        pointsData = this.localStorageService.get('CalculatedPoints');
        this.aviosToEarn = pointsData ? pointsData.Avios : 0;
        this.elitePointsToEarn = pointsData ? pointsData.Elite : 0;
        this.warnUserOnBackPressed();
        this.listLocationWitget = this.generateListWidget();
        const bkiInfo = this.localStorageService.get('bookingInfo');
        let hmFlight: boolean = true;
        bkiInfo.order.orderItems.forEach(item => {
            if (item.type === 'flight') {
                item.passengerPrices.forEach(passenger => {
                    passenger.segmentPrices.forEach(segPrices => {
                        if(segPrices.ticketDesignator !== 'HM') {
                            hmFlight = false;
                        }
                    });
                });
            }
        });
        if(hmFlight) {
            this.holaMadridFlow = hmFlight;
        }
        let issueOrderInfo:any = this.CommonsSessionStorageService.get('issueOrderInfo');
        if (issueOrderInfo) {
            angular.forEach(issueOrderInfo.data?.order?.orderItems, (item) => {
                if (item.type === 'allianzFusion') {
                    this.allianzFusionContractNumber = item.contractNumber;
                }
            });
        }
        this.setDigitalDataInfo();
    };

    private setDigitalDataInfo = () => {
        const points = this.localStorageService.get('CalculatedPoints') || { Avios: '0', Elite: '0' };
        const dataLayer = {
            AviosEarned: parseInt(points.Avios)
        };
        this.DatalayerUtilsService.addDigitalDataInfo(dataLayer);
    };
    public checkMultiTripViewConditions = (): boolean => {
        const isOpenJaw =  !!this.CommonsSessionStorageService.get('openJaw');
        const isMultiTrip = !!this.CommonsSessionStorageService.get('multiCitySearch');
        return isOpenJaw||isMultiTrip;
    };
    public getSummaryInfo = ( { showPassegenerTaxesModal, selectedOnHold = undefined }: SetSummaryInfoProps ): SummaryProps => {
        const summary: SummaryProps = {
            title: this.$filter( 'translate' )( 'SUMMARY_TITLE' ),
            trips: [],
            passengers: {
                onClick: (pass: string) => {},
                types: [],
                total: ''
            },
            ancillaries: [],
            otherItems: [],
            isMultiTrip: false,
            totalPrice: '',
            upgradingBid: false
        };
        const bookingInfo: any = this.CommonsSessionStorageService.get( 'bookingInfo' );
        const headerModel: HeaderDataType = this.CommonsSessionStorageService.get( 'headerModel' );
        summary.trips = this.IbSummaryTransformerService.setTrips( bookingInfo.order.slices, bookingInfo.fareFamilyConditions[ 0 ] );
        summary.isMultiTrip = this.checkMultiTripViewConditions();
        summary.otherItems = this.IbSummaryTransformerService.setOtherItemsFromBasket( headerModel.headerModel.shoppingBasket );
        summary.totalPrice = headerModel.headerModel.shoppingBasket.total.formatted;
        summary.total = headerModel.headerModel.shoppingBasket.total.original;
        summary.totalDcc = headerModel.headerModel.shoppingBasket.total.totalDcc;
        summary.passengers.types = this.IbSummaryTransformerService.setPassengers( headerModel.headerModel.shoppingBasket.trips.trips[0].passengers );
        summary.passengers.total = headerModel.headerModel.shoppingBasket.trips.total.formatted;
        summary.passengers.onClick = showPassegenerTaxesModal;
        if ( selectedOnHold != null ) {
            summary.onholdPrice = headerModel.headerModel.shoppingBasket.total.formatted;
            return summary;
        }
        summary.ancillaries = this.IbSummaryTransformerService.getAncillaries( headerModel.headerModel );
        return summary;
    };

    public getPriceFormatted = ( price: number ) => {
        const currency = this.CurrencyService.getCurrencyObject( this.CommonsSessionStorageService.get<CommercialDataMarket>( 'commercialData' ).currency );
        return this.CurrencyService.formatPrice( currency, price, true, false );
    };

    private getInitialSummary = (): SummaryProps => {
        if ( this.selectedOnHoldOption !== null ) {
            const onHoldSummary: SummaryProps = this.getSummaryInfo( { selectedOnHold: this.selectedOnHoldOption } );
            return onHoldSummary;
        }
        const summary: SummaryProps = this.getSummaryInfo( { showPassegenerTaxesModal: this.showPassegenerTaxesModal } );
        return summary;
    };

    private showPassegenerTaxesModal = ( passegener: string ) => {
        const createOrder: any = this.CommonsSessionStorageService.get( 'createOrderData' );
        const order: Order | null = createOrder?.order || null;
        if ( order == null ) return;
        const { passengerPrices } = order.orderItems[ 0 ];
        const passInfo: PassengerPrices | undefined = passengerPrices.find( ( pass: PassengerPrices ) => pass.passengerId.includes( passegener ) );
        if ( passInfo == null ) return;
        const { taxes } = passInfo;
        const mapTaxes: Taxes[] = taxes.map( ( tax: Taxes ) => {
            return <Taxes> <unknown> {
                description: tax.description,
                amount: this.getPriceFormatted( tax.amount )
            };
        } );
        this.showTaxesModal( mapTaxes );
    };

    public showTaxesModal = ( viewModel: Taxes[] ) => {
        const modalOptions = {
            temaplate: 'ib-modal-payment-taxes.html',
            windowClass: 'ib-modals bki-dialog'
        };
        this.PmtModalService.showGenericModal( false, modalOptions.temaplate, viewModel, modalOptions.windowClass ).result.then( () => { }, () => { } );
    };

    public onClickUpgrade (){
        const digitalData = {
            'eventName': 'interaccion',
            'eventCategory': 'registro',
            'eventAction': 'clic',
            'eventLabel': 'compra:upgrade registro'
        };
        window.dataLayer.push(digitalData, {'event':'interaction'});
    }

    public deleteTemporalPNR () {
        this.CommonsBrowserStorageService.remove('temporalPNR');
        this.DigitalDataService.emitEvent('remove_temporalPNR');
    }

    public updateDatalayerInfoPurchase () {
        const previousStepFlow = this.localStorageService.get('previousStepFlow');

        if(previousStepFlow !== this.PmtConstants.COMPONENT_PAGE.PAYMENTS_PAGE) {
            return;
        }
        this.DatalayerEcommerceUtilsService.setAddPurchase(this.model.confirmationInfo);
    }

    $onInit = this.activate();
}
